<template>
		<div class="card mt-3 mb-3 no-border border-radius-2">
			<div class="card-body">
				<div class="form-group">
					<label style="white-space: pre-wrap">{{ question.text }}</label>
					<template v-if="(question.type === '1')">
						<div class="btn-group btn-group-vertical-sm" style="display: block">
							<button
								class="btn p1"
								:class="{
									'btn-on': value == response.id,
									'btn-off': value != response.id,
									'btn-emoji': (response.text === '' && response.emoji)
								}"
								v-on:click="value = response.id; ResponseType = response.ResponseType"
								v-for="response in question.responses"
								:key="response.id"
							>
								{{ response.text ? response.text : '' }}
								{{ response.emoji ? String.fromCodePoint(response.emoji) : '' }}
							</button>
						</div>
					</template>
					<template v-if="(question.type === '2')">
						<textarea v-model="value" class="form-control"></textarea>
					</template>
				</div>
			</div>
		</div>
</template>

<script>
export default {
	props: {
		question: Object
	},
	data() {
		return {
			value: null,
			response: null
		}
	},
	computed: {
	},
	methods: {
		getValue() {//the value that is usually returned is the reponse.id, but we have an extra column in the DB called "Value", so we might want to use it
			return this.value;
		}
	}
};
</script>
